// module.exports = {
//   google: {
//     API_KEY: "",
//     CLIENT_ID: "23144678283-oek7ncjmmrgkgmi2i56sc411gp71a8sp.apps.googleusercontent.com",
//     SECRET: "",
//   },
//   facebook: {
//     APP_ID: "",
//   },
// }

export const config = {
  // clientId: "a103b2f8-0b31-4a89-a8d8-b7a79bbb6022",
  clientId: "5380da7f-c18d-468a-adeb-619e0b6ca075",
  // redirectUri: "http://localhost:3000",
  // redirectUri: "http://103.104.124.147:9035/",
  redirectUri: process.env.REACT_APP_REDIRECT_URL,

  scopes: ["user.read"],

  authorities: [
    {
      type: "AAD",
      audience: {
        type: "AzureADMyOrg",
        tenant_id: "82f04460-6131-498e-9f9b-b7a2a0411c25",
      },
    },
  ],
}
